import { Injectable } from '@angular/core';
import { VestmentColor } from '../../../objects';
import { ApiService } from '../../../services/api.service';

@Injectable()
export class VestmentColorService {
 
  private cache: VestmentColor[];

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<VestmentColor[]> {

    const p = new Promise<VestmentColor[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("VestmentColor cache detected");
        resolve(this.cache);
        return;
      }

      this.apiSvc.get("api/VestmentColor", null).subscribe(
        (data: VestmentColor[]) => {
          console.log(data);
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

  });

  return p;

}

public getItem(itemId: number): Promise<VestmentColor> {

  const p = new Promise<VestmentColor>((resolve, reject) => {

    this.apiSvc.get("api/VestmentColor/GetItem/" + itemId, null).subscribe(
      (data: VestmentColor) => {
        console.log("VestmentColor/GetItem", data);
        resolve(data);
      },
      (err) => {
        console.log("error", err);
      }
    );

  });

  return p;
}

  public save(model: VestmentColor): Promise<VestmentColor> {

    const p = new Promise<VestmentColor>((resolve, reject) => {

      this.apiSvc.post("api/VestmentColor/save", model).subscribe(
        (data: VestmentColor) => {
            resolve(data);
        },
        (err) => {
          console.log("error", err);
        //  this.isLoading = false;
        }
      );

    });

  return p;
  }
}
